import { render, staticRenderFns } from "./PaperReportTable.vue?vue&type=template&id=6dd88b8e&scoped=true"
import script from "./PaperReportTable.vue?vue&type=script&lang=js"
export * from "./PaperReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd88b8e",
  null
  
)

export default component.exports